<template>
  <v-snackbar
      v-model="notificacao.mostrar"
      :color="notificacao.cor"
      :right="right"
      :top="top"
      :timeout="timeout"
      dark
  >
    <div class="containerMsg">
      <div class="containerMsgBody" @click="dispararEvento">
        <v-icon class="mr-2" color="white">error</v-icon>
        <div class="body">
          <span class="title">{{ notificacao.titulo }}</span>
          <a class="msg">{{ notificacao.mensagem }}</a>
        </div>
      </div>
      <v-icon @click="fecharNotificacao" size="16">mdi-close-circle</v-icon>
    </div>
  </v-snackbar>
</template>

<script>
import {mapState} from 'vuex'
import {mutationTypes} from '@/core/constants'

export default {
    name: 'notificacao',
    data: () => ({
        top: true,
        right: true,
        timeout: 6000
    }),
    computed: {
        ...mapState(['notificacao'])
    },
    destroyed() {
        this.fecharNotificacao()
    },
    methods: {
        fecharNotificacao() {
            this.$store.commit(mutationTypes.COMUM.SET_NOTIFICACAO, {
                cor: this.notificacao.cor,
                titulo: '',
                mensagem: '',
                mostrar: false,
                eventoClick: null
            })
        },
        dispararEvento() {
            if (!this.notificacao.eventoClick) return
            this.$emit('eventoNotificacao', this.notificacao.eventoClick)
            this.fecharNotificacao()
        }
    }
}
</script>

<style scoped lang='stylus'>

.containerMsg
  display flex
  flex-direction row
  justify-content space-between
  padding 0px
  margin 0px

.containerMsgBody
  display flex
  flex-direction row
  padding 0px
  margin 0px

.body
  display flex
  flex-direction column
  justify-content center
  margin 0px

.title
  color #FFF

.msg
  color #FFF
  margin-right 5px
</style>